import { render, staticRenderFns } from "./attribution.vue?vue&type=template&id=e11679b2"
import script from "./attribution.vue?vue&type=script&lang=js"
export * from "./attribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports